// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-30T17:28:07.546Z
// Property: Quinn Residences at McCart Landing (ID: 6767906449167651)
// Collections: 22 amenities, 4 floorplans (live), 16 photos, 44 POIs, 5 reviews, 4 virtual tours, 6 office hours, 1 special offers (live), 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167651",
  "property_external_id": "1694769",
  "property_zillow_url": "https://www.zillow.com/b/quinn-residences-at-mccart-landing-conyers-ga-Cf2T9S/",
  "property_apartments_url": "https://www.apartments.com/quinn-residences-at-mccart-landing-conyers-ga/hmnqbb2/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "57160263295",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "quinn-residences-at-mccart-landing",
  "property_name": "Quinn Residences at McCart Landing",
  "property_website_url": "https://www.mccartlanding.com",
  "property_domain": "https://www.mccartlanding.com",
  "property_address": "4449 Lexington Court",
  "property_full_address": "Lexington Court, Conyers, GA 30013",
  "property_address_1": "4449 Lexington Court",
  "property_address_2": null,
  "property_address_city": "Conyers",
  "property_address_state": "GA",
  "property_address_zip_full": "30013",
  "property_address_zip": "30013",
  "property_address_country": "US",
  "property_address_county": "Rockdale County",
  "property_neighborhood_address": "Rockdale County",
  "property_address_latitude": "33.649563",
  "property_address_longitude": "-83.942202",
  "property_email": "McCart.RENTCafecomILS.Quinn@assist.rent",
  "property_phone": "(762) 946-7763",
  "property_call_tracking_phone": "762-946-7763",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Single-family homes",
  "property_short_description": "<p><strong>Brand-new detached rental homes in Conyers.</strong> Enjoy a spacious four-bedroom layout with an attached garage, smart-home features, modern finishes, and professional lawn maintenance—then schedule a tour to see McCart Landing in person.</p>",
  "property_long_description": "<p><strong>Brand-new detached rental homes in Conyers, GA.</strong> At Quinn Residences at McCart Landing, you can enjoy the feel of a spacious four-bedroom home with the ease of professional lawn maintenance and modern rental convenience. Explore open, light-filled <a href=\"/floor-plans\">four-bedroom layouts</a> with attached garages, in-unit laundry, smart-home technology, stainless steel appliances, granite countertops, luxury flooring, generous closets, and EV charger-ready garage access.</p><p>Beyond your front door, <a href=\"/amenities\">community amenities</a> like a clubhouse, pavilion, and tennis courts add everyday flexibility without sacrificing the quiet comfort of a residential setting. You’re close to I-20 for east-metro Atlanta access, with Olde Town Conyers dining, shopping, events, and the Lewis Vaughn Botanical Garden nearby. Outdoor and event destinations—including the Georgia International Horse Park, Rockdale River Trail, and local parks—bring more ways to spend time close to home. See what makes this Conyers rental home community stand out, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-34ec-727f-bc99-0a3b6884df85.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of a two-story brick house with a two-car garage and a well-maintained lawn.",
    "public_id": "019fec37-34ec-727f-bc99-0a3b6884df85",
    "storage_key": "property/6767906449167651/019fec37-34ec-727f-bc99-0a3b6884df85.webp",
    "width": 1280,
    "height": 920
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167651/01a0c01c-6fea-767b-aabe-53c2f7edf8dc.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c01c-6fea-767b-aabe-53c2f7edf8dc",
    "storage_key": "property/6767906449167651/01a0c01c-6fea-767b-aabe-53c2f7edf8dc.mp4",
    "thumbnail_key": "property/6767906449167651/01a0c01c-6fea-767b-aabe-53c2f7edf8dc_thumb.webp",
    "size_bytes": 24475638,
    "classification": "Community",
    "title": "Explore the Beautiful Streets and Homes of Our New Community",
    "description": "Take a virtual tour of our charming neighborhood, showcasing well-maintained streets, diverse home exteriors, and the natural beauty surrounding our community."
  },
  "property_total_units": "99",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": "0",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "89.8989898989899",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge package $10.95, landscaping $125, smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval. Pet screening is mandatory before move-in.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply; pet screening is required before move-in.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://mccartlanding.securecafe.com/onlineleasing/mccart-landing/floorplans.aspx",
  "property_resident_portal_url": "https://mccartlanding.securecafenet.com/residentservices/mccart-landing/userlogin",
  "property_apply_now_url": "https://mccartlanding.securecafe.com/onlineleasing/mccart-landing/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/01a0d047-6f7f-756a-8e52-cf5c637d2c3d.webp",
  "property_primary_logo_media": {
    "alt_text": "Quinn Residences at McCart Landing logo",
    "public_id": "01a0d047-6f7f-756a-8e52-cf5c637d2c3d",
    "storage_key": "property/6767906449167651/01a0d047-6f7f-756a-8e52-cf5c637d2c3d.webp",
    "width": 387,
    "height": 64
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/01a0d047-de9d-77e8-8e41-f0c6f10e0cfe.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0d047-de9d-77e8-8e41-f0c6f10e0cfe",
    "storage_key": "property/6767906449167651/01a0d047-de9d-77e8-8e41-f0c6f10e0cfe.webp",
    "width": 387,
    "height": 64
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/01a0d047-d39a-71f7-bc2e-e6055af8b679.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0d047-d39a-71f7-bc2e-e6055af8b679",
    "storage_key": "property/6767906449167651/01a0d047-d39a-71f7-bc2e-e6055af8b679.webp",
    "width": 387,
    "height": 64
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#602a26",
  "property_secondary_color": "#333332",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "4 - 4",
  "property_bedrooms_min": "4",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2.5 - 2.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "2108 - 2234",
  "property_sqft_min": "2108",
  "property_sqft_max": "2254",
  "property_price_range": "2482 - 2886",
  "property_price_min": "2382",
  "property_price_max": "2781",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=100094335107056",
  "property_instagram_url": "https://www.instagram.com/mccartlanding/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ69AuYOwz9IgRqkQRxkr27tw",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Quinn Residences at McCart Landing",
  "property_home_romance_title": "Embrace Life in Your Brand-New Rental Home",
  "property_home_amenities_blurb": "<p><strong>Detached-home ease, everyday polish.</strong> Enjoy granite countertops, stainless steel appliances, smart-home features, in-unit laundry, and garage access ready for EV charging—all with lawn maintenance handled. Beyond your door, a clubhouse, pavilion, and tennis courts add easy options to gather, recharge, or stay active close to home in Conyers.</p>",
  "property_home_floorplans_blurb": "<p><strong>Four-bedroom space, simplified.</strong> Explore Roberta, Spencer, Xavier, and Sanford—spacious rental home designs with open living areas, generous closets, attached garages, and modern finishes like granite countertops, stainless steel appliances, luxury flooring, and smart-home technology. In-unit laundry, lawn maintenance, and EV charger-ready garage access add everyday ease, so comparing layouts and finding the right fit feels refreshingly straightforward.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture the details.</strong> Preview detached rental homes in Conyers with bright kitchens, stainless steel appliances, granite countertops, luxury flooring, organized closet space, attached garages, and fenced yards. Then explore community views from the clubhouse and pavilion to the tennis courts.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Conyers, mapped your way.</strong> From Quinn Residences at McCart Landing, daily stops along Salem Road and GA-20/138 meet Olde Town flavor, downtown murals, and outdoor escapes. Grab Thai Palace &amp; Sushi Bar or Celtic Tavern, catch Center Street Arts, then spend the weekend at Georgia International Horse Park, Johnson Park, or the Arabia Mountain PATH system. Explore the map and see how convenience connects with an easygoing east-metro setting.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident feedback points to service that stands out.</strong> Reviews for Quinn Residences at McCart Landing highlight clear communication, patient guidance, and responsive follow-up from the leasing team—often naming Tayvin, Altivia, and Maria. Residents also note the community’s beautiful layout, clean and quiet surroundings, and service requests handled quickly. See why reviews describe the experience as smooth, welcoming, and well organized.</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the map, then make the day your own.</strong> From Quinn Residences at McCart Landing, Conyers opens up in easy layers: errands along the Salem Road and GA-20/138 corridors, local flavor in historic Olde Town, and outdoor escapes when you want more green than screen time. Try Thai Palace &amp; Sushi Bar, Celtic Tavern, or Creamberry’s, catch a performance at Center Street Arts, then wander downtown murals and the Olde Town Pavilion before heading home.</p><p>Weekends can shift from festivals and food trucks to trail time at the Georgia International Horse Park, Johnson Park, or the Arabia Mountain PATH system. Explore the neighborhood map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this Conyers location connects daily convenience with an easygoing east-metro setting.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Room to live, finished for real routines.</strong> At Quinn Residences at McCart Landing, amenities start inside your detached rental home: a polished kitchen with stainless steel appliances and granite countertops, smart-home features, in-unit laundry, and garage access that’s ready for EV charging. Lawn maintenance is handled for you, so outdoor time feels easier to enjoy, not harder to keep up.</p><p>When you want a change of setting, the clubhouse, pavilion, and tennis courts give you comfortable places to gather, unwind, or stay active close to home in Conyers. See the finishes and community spaces in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities firsthand.</p>",
  "property_applynow_blurb": "<p><strong>Ready for a brand-new detached rental home?</strong> Quinn Residences at McCart Landing brings together spacious four-bedroom layouts, attached garages, smart-home technology, in-unit laundry, and professional lawn maintenance for modern rental ease. Start your online application today and take the next step toward calling this Conyers community home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Connect with the leasing team at Quinn Residences at McCart Landing to learn more about brand-new detached four-bedroom rental homes in Conyers, modern rental conveniences, and professional lawn maintenance. We’re here to help you plan your next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Quinn Residences at McCart Landing?</strong> Start here for quick answers about brand-new detached rental homes, leasing, features, and everyday living in Conyers. If you need anything more, the leasing team is happy to help or schedule a tour when you’re ready.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that fits the way you live.</strong> Quinn Residences at McCart Landing keeps the decision simple with four spacious four-bedroom home designs—Roberta, Spencer, Xavier, and Sanford—each giving you the feel of a detached rental home in Conyers with room to spread out, settle in, and stay organized. Compare open living areas, generous closets, attached garage convenience, and modern finishes like granite countertops, stainless steel appliances, luxury flooring, and smart-home technology. In-unit laundry and lawn maintenance add everyday ease, while EV charger-ready garage access brings forward-thinking flexibility to your routine. Browse current pricing and availability, view the layouts side by side, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see which floor plan feels like home.</p>",
  "property_gallery_blurb": "<p><strong>See the details come into focus.</strong> Browse the photo gallery at Quinn Residences at McCart Landing and picture the everyday scenes that define these detached rental homes in Conyers: bright kitchens with stainless steel appliances and granite countertops, open living spaces grounded by luxury flooring, and bedrooms with closets made to keep things organized.</p><p>Outside, the images move from attached garages and fenced yards to the clubhouse, pavilion, and tennis courts, giving you a clear look at how home and community spaces connect. After you explore the gallery, compare <a href=\"/floor-plans\">four-bedroom floor plans</a>, step through <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite views in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore McCart Landing on the map.</strong> Browse available detached four-bedroom rental homes, then see how close Conyers dining, shopping, parks, events, and I-20 access can be from your front door.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with space to stretch.</strong> At Quinn Residences at McCart Landing, your cat or dog can feel at home in a detached rental residence with open living areas, air conditioning, smart-home convenience, and a private backyard for everyday fresh-air breaks. Larger pets have room to settle in, too, with a policy designed for cats and dogs up to 100 pounds each.</p><p>When you want a change of scenery, nearby off-leash options add water stations, waste stations, and agility features to your routine before you head back to the comfort of home. Review the pet details below, explore more <a href=\"/amenities\">home and community features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to picture daily life with your companion here.</p>",
  "property_referafriend_blurb": "<p><strong>Share the space, ease, and modern rental convenience you love.</strong> Invite a friend to discover brand-new detached four-bedroom rental homes with attached garages, smart-home technology, professional lawn maintenance, and comfortable community spaces at Quinn Residences at McCart Landing.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access made simple.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account at Quinn Residences at McCart Landing—brand-new detached rental homes with modern rental convenience, professional lawn maintenance, smart-home technology, and attached garage living in Conyers.</p>",
  "property_reviews_blurb": "<p><strong>Real experiences, shared in residents’ own words.</strong> As you browse reviews for Quinn Residences at McCart Landing, you’ll see a consistent theme: caring, responsive service from the first call through move-in and beyond.</p><p>Residents frequently praise team members like Tayvin, Altivia, and Maria for clear communication, patience, follow-up, and making the leasing process feel “smooth and stress-free.” Reviewers also call out the beautiful, well-laid-out community, clean and quiet surroundings, and service requests handled almost immediately. Read what residents have to say and see why so many describe their experience here as welcoming, organized, and truly positive.</p>",
  "property_created_at": "1786374350204",
  "property_scheduletour_blurb": "<p><strong>See comfort, convenience, and community up close.</strong> Tour Quinn Residences at McCart Landing and experience brand-new, pet-friendly four-bedroom detached homes with fenced-in yards, smart technology, resort-style amenities, and a maintenance-free lifestyle in Conyers. Schedule your visit today and picture life here from the doorstep.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Our leasing team will follow up soon with more information about Quinn Residences at McCart Landing, where brand-new four-bedroom detached homes, fenced-in spaces, smart technology, pet-friendly living, and a maintenance-free lifestyle bring comfort and convenience together in Conyers.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "© 2026 Quinn Residences. All rights reserved.",
  "property_seo_title_home": "Quinn Residences at McCart Landing |  Apartments in Conyers, GA",
  "property_seo_description_home": "Discover luxury living at Quinn Residences in Conyers, GA. Enjoy spacious four-bedroom layouts, modern amenities, and smart-home features!",
  "property_seo_title_floorplans": "Floor Plans | Conyers, GA Apartments for Rent",
  "property_seo_description_floorplans": "Discover your ideal home at Quinn Residences! Explore our spacious four-bedroom floor plans in Conyers, GA, and envision your new lifestyle!",
  "property_seo_title_amenities": "Amenities | Conyers, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience upscale living at Quinn Residences! Enjoy luxury amenities like tennis courts, smart-home tech, and stunning floor plans in vibrant Conyers, GA.",
  "property_seo_title_gallery": "Gallery | Apartments in Conyers, GA",
  "property_seo_description_gallery": "Picture your life at Quinn Residences in Conyers! Enjoy luxury floor plans, top-notch amenities, and smart-home tech. See the beautiful spaces that await!",
  "property_seo_title_virtualtours": "Virtual Tours | Quinn Residences at McCart Landing Apartments",
  "property_seo_description_virtualtours": "Experience modern living at Quinn Residences in Conyers, GA. Take a virtual tour of our spacious four-bedroom apartments and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Quinn Residences at McCart Landing Apartments",
  "property_seo_description_interactivemap": "Find your perfect fit at Quinn Residences in Conyers, GA! Check out our interactive map to view spacious four-bedroom homes with luxury amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Conyers, GA",
  "property_seo_description_neighborhood": "Discover the charm of Conyers at Quinn Residences! Explore nearby treasures that make our vibrant neighborhood a delightful place to live.",
  "property_seo_title_contact": "Contact Us | Quinn Residences at McCart Landing",
  "property_seo_description_contact": "Discover spacious four-bedroom floor plans at Quinn Residences, McCart Landing, Conyers, GA! Contact our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Conyers, GA",
  "property_seo_description_faqs": "Find answers to your questions about Quinn Residences in Conyers, GA! Enjoy luxury living with top-notch amenities and spacious four-bedroom floor plans.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Conyers, GA",
  "property_seo_description_reviews": "Experience life at Quinn Residences in Conyers, GA—where luxury meets comfort! Read real resident reviews and see why our community feels like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Conyers, GA",
  "property_seo_description_applynow": "Experience luxury living at Quinn Residences in Conyers, GA. Modern amenities and smart home features await. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Quinn Residences at McCart Landing",
  "property_seo_description_residentaccess": "Access your Quinn Residences portal for effortless rent payments, maintenance requests, and community updates. Your convenience in Conyers, GA awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Quinn Residences at McCart Landing",
  "property_seo_description_referafriend": "Share the love at Quinn Residences! Refer a friend and enjoy rewarding community perks in vibrant Conyers, GA—where friendship and home meet.",
  "property_seo_title_scheduletour": "Schedule a Tour | Quinn Residences at McCart Landing",
  "property_seo_description_scheduletour": "Experience modern living at Quinn Residences in Conyers, GA. Schedule your tour today and envision your new lifestyle in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Quinn Residences at McCart Landing",
  "property_seo_description_privacy": "Your privacy matters at Quinn Residences. Learn how we protect your personal information and ensure a secure living experience in Conyers, GA.",
  "property_seo_title_accessibility": "Website Accessibility | Quinn Residences at McCart Landing",
  "property_seo_description_accessibility": "At Quinn Residences, we prioritize accessibility for all. Join us in promoting digital inclusion as we break barriers in Conyers, GA living.",
  "property_seo_title_sitemap": "Sitemap | Quinn Residences at McCart Landing",
  "property_seo_description_sitemap": "Uncover the charm of Quinn Residences at McCart Landing in Conyers, GA. Navigate our sitemap for a glimpse of your future home and community offerings.",
  "property_seo_title_thankyou": "Thank You | Quinn Residences at McCart Landing",
  "property_seo_description_thankyou": "Thank you for your interest in Quinn Residences at McCart Landing! Our team will be in touch soon to help you find your ideal Conyers, GA home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Conyers, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793287398903",
  "amenities": [
    {
      "id": "custom_b9ff01ce-6c66-451c-95db-fd9fafce1d1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906886",
      "title": "Tennis Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7d90ce8-0f8a-44ae-a98e-e6d43b14dca2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906885",
      "title": "Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7e3180e-9e9d-48cd-bc68-df9902b551f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906884",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c9740ac-914c-4f94-8744-21efcbd4bd29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "129051957",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71dd954c-9426-43dd-ab48-160b699d6a7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "129051956",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fec83ffb-2917-48ef-8dc1-f5e50dfa98ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "129051937",
      "title": "Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e98fabf6-70a0-43bc-a566-3d8199f20eb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "129051935",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d91c28a9-1aea-47b3-aada-58a991d767af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "129051933",
      "title": "Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b119daf9-5712-47af-9389-38069026943c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "129051932",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aaab32a1-c9f5-478e-89a3-f0e6a975b7c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906897",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_363aa118-c5f1-44f8-a52a-3816169516fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906895",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e0772a6-d6b9-48b2-889d-1d0aa86c1a7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906892",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_472273b3-21ba-49f5-93b4-1ecbb7dca154",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906893",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_43256701-a165-4c29-a532-b9a4a47468cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906894",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e77c464-21cb-4913-ab6d-a846748af27f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "129051936",
      "title": "High Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_abefcf35-8274-4123-9b59-541f4cbd7e24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906887",
      "title": "Pavilion",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f5e99ec9-7a2d-4d61-8901-705dd49ed0eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906898",
      "title": "Smart-Home Technology",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0e8661e4-c30b-488f-b5cd-a30935c32a05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "120906906",
      "title": "Private Backyard",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_142952d8-2e4b-42ab-95c4-5c047532d25d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "129051953",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2111c84-fc6d-470f-9d87-b51ab85b99fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "129051966",
      "title": "Spacious Backyards",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9f87aead-26e3-43ac-8642-d5b863e549c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "129051981",
      "title": "EV Charger-Ready Garages",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4f3e7e8c-e4a7-45c8-b2c1-5f6e092eaf28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "external_id": "false",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_308270fa18d18be6d8af79af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-34ec-727f-bc99-0a3b6884df85.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story brick house with a two-car garage and a well-maintained lawn.",
        "public_id": "019fec37-34ec-727f-bc99-0a3b6884df85",
        "storage_key": "property/6767906449167651/019fec37-34ec-727f-bc99-0a3b6884df85.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Charming two-story brick home featuring a spacious two-car garage and situated on a lush, green lot. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "A two-story house with a garage and a driveway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/spencer-exterior.jpg"
    },
    {
      "id": "ec_3dc7fe2d5e9e86a0f1ce1287",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-413a-733d-b735-78e1f2a72d54.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "019fec37-413a-733d-b735-78e1f2a72d54",
        "storage_key": "property/6767906449167651/019fec37-413a-733d-b735-78e1f2a72d54.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Experience culinary excellence in our spacious kitchen, featuring sleek white cabinets, elegant granite countertops, and state-of-the-art stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a center island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/xavier-kitchen.jpg"
    },
    {
      "id": "ec_dbbae7d24858eb3e91b896e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-3422-729e-9342-2cf1f8f8c02d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinets.",
        "public_id": "019fec37-3422-729e-9342-2cf1f8f8c02d",
        "storage_key": "property/6767906449167651/019fec37-3422-729e-9342-2cf1f8f8c02d.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "This spacious kitchen features sleek stainless steel appliances, elegant granite countertops, and ample white cabinetry for all your storage needs.",
      "link": "false",
      "alt_text": "A kitchen with a granite countertop and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/spencer-kitchen.jpg"
    },
    {
      "id": "ec_8632b3e76ab48f0128468537",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-2f80-7249-b387-29c8979a1e7e.webp",
      "image_media": {
        "alt_text": "Modern open-concept kitchen with light gray cabinets, a large island, and stainless steel appliances.",
        "public_id": "019fec37-2f80-7249-b387-29c8979a1e7e",
        "storage_key": "property/6767906449167651/019fec37-2f80-7249-b387-29c8979a1e7e.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Experience seamless living in this beautifully appointed open-concept kitchen, perfect for entertaining and everyday life. Features sleek cabinetry and a spacious island.",
      "link": "false",
      "alt_text": "A spacious kitchen with a bar area and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/roberta-living.jpg"
    },
    {
      "id": "ec_2ff8eafedf6cac5cb9e9f810",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-354b-7549-bdd8-8b0affdeb15e.webp",
      "image_media": {
        "alt_text": "Spacious open-concept living area with kitchen, dining, and living room spaces. Features stainless steel appliances, a kitchen island, and a staircase.",
        "public_id": "019fec37-354b-7549-bdd8-8b0affdeb15e",
        "storage_key": "property/6767906449167651/019fec37-354b-7549-bdd8-8b0affdeb15e.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Experience modern living in this open-concept layout, perfect for entertaining and everyday life. Includes a fully equipped kitchen with island, a bright living area, and elegant finishes.",
      "link": "false",
      "alt_text": "A spacious kitchen with a refrigerator, microwave, and stove top oven.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/spencer-living.jpg"
    },
    {
      "id": "ec_1ec68483a79b701aed52b316",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-46f5-74e3-9739-43a8bdfd06de.webp",
      "image_media": {
        "alt_text": "Spacious living room with light wood laminate flooring and large windows.",
        "public_id": "019fec37-46f5-74e3-9739-43a8bdfd06de",
        "storage_key": "property/6767906449167651/019fec37-46f5-74e3-9739-43a8bdfd06de.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious room featuring light wood laminate flooring and abundant natural light from large windows.",
      "link": "false",
      "alt_text": "A room with a ceiling fan and wooden flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/xavier-living.jpg"
    },
    {
      "id": "ec_bd5ae7c81534753eed32a283",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-1df2-7114-b991-7b3a372fb293.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and tennis courts at a multifamily property.",
        "public_id": "019fec37-1df2-7114-b991-7b3a372fb293",
        "storage_key": "property/6767906449167651/019fec37-1df2-7114-b991-7b3a372fb293.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling swimming pool and pristine tennis courts. Perfect for relaxation and recreation.",
      "link": "false",
      "alt_text": "A tennis court is surrounded by a pool and a house.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/amenity.jpg"
    },
    {
      "id": "ec_d5e7d1c0aa98bf433a7a2e02",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-435e-744b-aa35-6650c425f3e7.webp",
      "image_media": {
        "alt_text": "Front exterior of a two-story brick house with a two-car garage and manicured lawn.",
        "public_id": "019fec37-435e-744b-aa35-6650c425f3e7",
        "storage_key": "property/6767906449167651/019fec37-435e-744b-aa35-6650c425f3e7.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Charming two-story brick home featuring a spacious two-car garage, elegant windows with shutters, and a welcoming front entrance, surrounded by lush greenery.",
      "link": "false",
      "alt_text": "A two-story house with a garage and a driveway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/xavier-exterior.jpg"
    },
    {
      "id": "ec_57a39ae3a0389f4d42b5d907",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-2041-77c1-9a72-6060b3808f54.webp",
      "image_media": {
        "alt_text": "Exterior of a brick two-story house with a two-car garage, shutters, and manicured lawn.",
        "public_id": "019fec37-2041-77c1-9a72-6060b3808f54",
        "storage_key": "property/6767906449167651/019fec37-2041-77c1-9a72-6060b3808f54.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Showcasing the charming exterior of this beautiful brick home, featuring a spacious two-car garage, classic shutters, and a lush, green lawn perfect for outdoor enjoyment.",
      "link": "false",
      "alt_text": "A house with a grey roof and a white garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/roberta-exterior.jpg"
    },
    {
      "id": "ec_537bd83f5e2af5057cf25b50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-0e34-71a3-bb10-13257d128633.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban street lined with new construction houses.",
        "public_id": "019fec37-0e34-71a3-bb10-13257d128633",
        "storage_key": "property/6767906449167651/019fec37-0e34-71a3-bb10-13257d128633.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Discover a new neighborhood with charming homes and a welcoming streetscape. Ideal for families seeking a peaceful community atmosphere.",
      "link": "false",
      "alt_text": "A residential street with houses on both sides.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/aerial-3(2).jpg"
    },
    {
      "id": "ec_a61e87e8af0525cb2ed74651",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-1d23-716f-b06f-167ccdb9a091.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with modern houses and manicured lawns.",
        "public_id": "019fec37-1d23-716f-b06f-167ccdb9a091",
        "storage_key": "property/6767906449167651/019fec37-1d23-716f-b06f-167ccdb9a091.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Discover charming homes nestled in a picturesque suburban community, offering a serene and comfortable lifestyle.",
      "link": "false",
      "alt_text": "A suburban neighborhood with houses and a road intersection.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/aerial-4(3).jpg"
    },
    {
      "id": "ec_5d17e052217b3f99b633f49c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-1cba-721d-adaf-4e3e713cf642.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with arched entryway and manicured landscaping.",
        "public_id": "019fec37-1cba-721d-adaf-4e3e713cf642",
        "storage_key": "property/6767906449167651/019fec37-1cba-721d-adaf-4e3e713cf642.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Charming brick building with an arched entryway, complemented by lush green landscaping and mature trees under a bright, cloudy sky.",
      "link": "false",
      "alt_text": "A house with a brick facade and a black roof with a brown window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/clubhouse.jpg"
    },
    {
      "id": "ec_153c77e7b058afb4dec012d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-21be-755f-bb95-8aca5009ba69.webp",
      "image_media": {
        "alt_text": "Covered patio area with seating and tables next to a swimming pool.",
        "public_id": "019fec37-21be-755f-bb95-8aca5009ba69",
        "storage_key": "property/6767906449167651/019fec37-21be-755f-bb95-8aca5009ba69.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this spacious covered patio, perfect for relaxing or gathering with friends, located conveniently by the community pool.",
      "link": "false",
      "alt_text": "A covered patio area with a table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/pool-pavilion.jpg"
    },
    {
      "id": "ec_f8249212ff7764f6cfe212ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-2f90-75fa-ab59-cbaef1a4f615.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop and a walk-in closet and toilet area.",
        "public_id": "019fec37-2f90-75fa-ab59-cbaef1a4f615",
        "storage_key": "property/6767906449167651/019fec37-2f90-75fa-ab59-cbaef1a4f615.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, a large mirror, and a separate water closet. Includes a walk-in closet for ample storage.",
      "link": "false",
      "alt_text": "A bathroom with a sink, mirror, and wooden floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/roberta-bathroom.jpg"
    },
    {
      "id": "ec_c2300c5214b40cbe84bceee3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-3f56-727b-8ffd-4744759b8d70.webp",
      "image_media": {
        "alt_text": "View of a modern bathroom with a glass-enclosed shower, granite countertop vanity, and a walk-in closet.",
        "public_id": "019fec37-3f56-727b-8ffd-4744759b8d70",
        "storage_key": "property/6767906449167651/019fec37-3f56-727b-8ffd-4744759b8d70.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom featuring a spacious walk-in closet, elegant granite countertops, and a sleek glass shower enclosure.",
      "link": "false",
      "alt_text": "A white bathroom with a sink, mirror, and a walk-in shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/spencer-bathroom.jpg"
    },
    {
      "id": "ec_8fa8f17086070774000cbd15",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-42c2-763a-acb9-ab6ec8bc7410.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertop and large mirror",
        "public_id": "019fec37-42c2-763a-acb9-ab6ec8bc7410",
        "storage_key": "property/6767906449167651/019fec37-42c2-763a-acb9-ab6ec8bc7410.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious double vanity bathroom featuring a granite countertop, ample cabinet storage, and a large mirror, perfect for modern living.",
      "link": "false",
      "alt_text": "A bathroom with a sink, mirror, and wooden floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/xavier-bathroom.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_602f0bcf-1e06-45b8-9f3f-6f024557e7ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Virgil's Gullah Kitchen & Bar Conyers",
      "poi_type": "Restaurants",
      "poi_address": "914 Commercial St NE, Conyers, GA 30012, USA",
      "poi_short_description": "Southern eatery with a bar, serving shrimp 'n' grits, fried chicken and other Southern staples.",
      "poi_long_description": "Southern eatery with a bar, serving shrimp 'n' grits, fried chicken and other Southern staples.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-1a34-7602-a949-f5ab10edf74b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-1a34-7602-a949-f5ab10edf74b",
        "storage_key": "property/6767906449167651/019fec38-1a34-7602-a949-f5ab10edf74b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.virgilsgullahkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14559642498250159503",
      "poi_item_slug": "virgils-gullah-kitchen--bar-conyers",
      "poi_latitude": "33.6666527",
      "poi_longitude": "-84.0174196",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 762-245-6541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b0cf20b63a5a",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO-ElaYSz9YgRj7XhPLY9Dso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cfb6dda8-3e7e-4a5f-9915-a052c39480f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Thai Palace & Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "968 South Main St NE, Conyers, GA 30012, USA",
      "poi_short_description": "Familiar Thai curries & stir-fries, plus a wide sushi menu, served in a restored Victorian building.",
      "poi_long_description": "Familiar Thai curries & stir-fries, plus a wide sushi menu, served in a restored Victorian building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-20cb-719f-9c97-6365ede708fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-20cb-719f-9c97-6365ede708fe",
        "storage_key": "property/6767906449167651/019fec38-20cb-719f-9c97-6365ede708fe.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://thaipalaceandsushibar.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=2228244180691869336",
      "poi_item_slug": "thai-palace--sushi-bar",
      "poi_latitude": "33.6655691",
      "poi_longitude": "-84.0155889",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-785-7778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b0cf20b63a5a",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtUY3l6e09YgRmF74zkZQ7B4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_a9ed60ee-0e19-4f9b-b190-f0a3633721b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Celtic Tavern Irish Pub & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "918 Commercial St NE, Conyers, GA 30012, USA",
      "poi_short_description": "Hangout with sandwiches, burgers & other bar fare, plus entertainment such as live music & karaoke.",
      "poi_long_description": "Hangout with sandwiches, burgers & other bar fare, plus entertainment such as live music & karaoke.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-1f21-711c-8952-3950755484b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-1f21-711c-8952-3950755484b7",
        "storage_key": "property/6767906449167651/019fec38-1f21-711c-8952-3950755484b7.webp",
        "width": 960,
        "height": 431
      },
      "poi_business_url": "https://celtictavern.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=17560395627796815519",
      "poi_item_slug": "celtic-tavern-irish-pub--restaurant",
      "poi_latitude": "33.6665366",
      "poi_longitude": "-84.01730859999999",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 470-276-6633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b0cf20b63a5a",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYztBhViz9YgRn94m1sgOs_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_pub"
    },
    {
      "id": "custom_158fa465-270f-425d-979e-b5ba1b2df152",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Whistle Post Tavern",
      "poi_type": "Restaurants",
      "poi_address": "935 Railroad St NW #5259, Conyers, GA 30012, USA",
      "poi_short_description": "Easygoing hangout featuring American dishes, brunch & a kids' menu, plus poker & live music.",
      "poi_long_description": "Easygoing hangout featuring American dishes, brunch & a kids' menu, plus poker & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-1a36-752b-aae3-18084df32c80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-1a36-752b-aae3-18084df32c80",
        "storage_key": "property/6767906449167651/019fec38-1a36-752b-aae3-18084df32c80.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.whistleposttavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18263154379449212293",
      "poi_item_slug": "whistle-post-tavern",
      "poi_latitude": "33.6674182",
      "poi_longitude": "-84.0190992",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-785-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b0cf20b63a5a",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2nr4Fiz9YgRhZ0wUSXCc_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_2cef3080-b3fe-492a-843f-73e9e03a7b3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Iron Skillet Southern Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "908 Commercial St NE, Conyers, GA 30012, USA",
      "poi_short_description": "Homestyle eatery providing popular Southern dishes like fried catfish, mac and cheese, cornbread and meatloaf.",
      "poi_long_description": "Homestyle eatery providing popular Southern dishes like fried catfish, mac and cheese, cornbread and meatloaf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-1baf-7268-aefb-12085b229b66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-1baf-7268-aefb-12085b229b66",
        "storage_key": "property/6767906449167651/019fec38-1baf-7268-aefb-12085b229b66.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ironskilletsouthernkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15000694804722396295",
      "poi_item_slug": "iron-skillet-southern-kitchen",
      "poi_latitude": "33.6668719",
      "poi_longitude": "-84.01765120000002",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-679-4435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b0cf20b63a5a",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJheUMl32z9YgRh6yGo3IsLdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a4d6faf8-7ff7-42c3-b6e7-313a8ae5f8a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Seis Hermanas Mexican Food",
      "poi_type": "Restaurants",
      "poi_address": "977 South Main St NE, Conyers, GA 30012, USA",
      "poi_short_description": "Casual restaurant serving traditional Mexican fare including tacos, burritos, and quesabirria, plus churros.",
      "poi_long_description": "Casual restaurant serving traditional Mexican fare including tacos, burritos, and quesabirria, plus churros.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-211b-762f-9ba0-3bd741ed81e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-211b-762f-9ba0-3bd741ed81e8",
        "storage_key": "property/6767906449167651/019fec38-211b-762f-9ba0-3bd741ed81e8.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://orderseishermanas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12729011399397196563",
      "poi_item_slug": "seis-hermanas-mexican-food",
      "poi_latitude": "33.6652343",
      "poi_longitude": "-84.01560789999999",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-679-9613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b0cf20b63a5a",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb8cGXv619YgRE8P3Mm2IprA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_00fa1bdc-580e-45bf-ad30-84d0afd7fa65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Ziggi's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1730 Hwy 138 SE, Conyers, GA 30013, USA",
      "poi_short_description": "Local coffeehouse chain serving classic brews & blended drinks, plus smoothies & light eats.",
      "poi_long_description": "Local coffeehouse chain serving classic brews & blended drinks, plus smoothies & light eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-1b36-77ef-a7ca-8b1d92d7a52b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-1b36-77ef-a7ca-8b1d92d7a52b",
        "storage_key": "property/6767906449167651/019fec38-1b36-77ef-a7ca-8b1d92d7a52b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ziggiscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5544851176776179282",
      "poi_item_slug": "ziggis-coffee",
      "poi_latitude": "33.6438219",
      "poi_longitude": "-84.0138391",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 470-665-2065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-6088-76bf-a66a-ed8404fcce01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec38-6088-76bf-a66a-ed8404fcce01",
        "storage_key": "property/6767906449167651/019fec38-6088-76bf-a66a-ed8404fcce01.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJtzThgIdL9IgRUp4mdMRE80w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_cd3a3e15-61e1-45d0-b0c4-881ab1dd1570",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Cozumel",
      "poi_type": "Restaurants",
      "poi_address": "116, 425 Sigman Rd NW, Conyers, GA 30012, USA",
      "poi_short_description": "Longtime shopping-center eatery & bar offering a huge menu of steaks, seafood & Mexican staples.",
      "poi_long_description": "Longtime shopping-center eatery & bar offering a huge menu of steaks, seafood & Mexican staples.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-27b5-760c-97ef-399991c765a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-27b5-760c-97ef-399991c765a3",
        "storage_key": "property/6767906449167651/019fec38-27b5-760c-97ef-399991c765a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cozmexrest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=784098038049646515",
      "poi_item_slug": "cozumel",
      "poi_latitude": "33.6855105",
      "poi_longitude": "-84.0020962",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-860-0801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b0cf20b63a5a",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b0cf20b63a5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TWlHI609YgRs6cH4wKt4Qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_2cacc691-6f46-4ba8-9345-4edb5845bda6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "1395 GA-138, Conyers, GA 30013, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-2615-75cb-b5f9-cf569c87381a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-2615-75cb-b5f9-cf569c87381a",
        "storage_key": "property/6767906449167651/019fec38-2615-75cb-b5f9-cf569c87381a.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ga/conyers/1395-georgia-hwy-138?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQwNTQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11950253495514240269",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "33.6590432",
      "poi_longitude": "-83.99847869999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-860-9692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-60ac-71a3-9a51-c92e6ac2bb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec38-60ac-71a3-9a51-c92e6ac2bb4d",
        "storage_key": "property/6767906449167651/019fec38-60ac-71a3-9a51-c92e6ac2bb4d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3dO_La09YgRDRX_Lz3U16U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_406741b8-96c0-4009-b7fc-95c7219cc725",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1436 Dogwood Dr SE, Conyers, GA 30013, USA",
      "poi_short_description": "Department store carrying everything from groceries and electronics to clothing, furniture, and toys.",
      "poi_long_description": "Department store carrying everything from groceries and electronics to clothing, furniture, and toys.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-2884-716b-bfe2-4904e57f9cff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-2884-716b-bfe2-4904e57f9cff",
        "storage_key": "property/6767906449167651/019fec38-2884-716b-bfe2-4904e57f9cff.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2475-conyers-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12586650098244144373",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.6528841",
      "poi_longitude": "-83.9966626",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-860-8544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a15d-73ec-a3af-c93c530418f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a15d-73ec-a3af-c93c530418f3",
        "storage_key": "property/6767906449167651/019fec35-a15d-73ec-a3af-c93c530418f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJd3Ge-0az9YgR9Uz60ZPDrK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_56a3eafc-5108-45fc-adcb-658bd8c27ad1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1745 Hwy 138 SE Ste A, Conyers, GA 30013, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-274a-701d-b0cd-6667d03ff887.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-274a-701d-b0cd-6667d03ff887",
        "storage_key": "property/6767906449167651/019fec38-274a-701d-b0cd-6667d03ff887.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/conyers/conyers-square/011/00320?cid=loc_01100320_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=508368384072544432",
      "poi_item_slug": "kroger",
      "poi_latitude": "33.6437445",
      "poi_longitude": "-84.0169607",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-922-8753",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a170-7625-b0cc-032a5e2b27b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a170-7625-b0cc-032a5e2b27b6",
        "storage_key": "property/6767906449167651/019fec35-a170-7625-b0cc-032a5e2b27b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzlACcO09YgRsPCuE1oWDgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_09c34170-980c-47d1-ab94-31a2e7b68478",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1794 GA-138, Conyers, GA 30013, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-288d-735f-bce3-58818275a5cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-288d-735f-bce3-58818275a5cc",
        "storage_key": "property/6767906449167651/019fec38-288d-735f-bce3-58818275a5cc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/conyers/1794-ga-highway-138/l941",
      "poi_directions_map_url": "https://maps.google.com/?cid=11383177735209384263",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.637762",
      "poi_longitude": "-84.016493",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a170-7625-b0cc-032a5e2b27b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a170-7625-b0cc-032a5e2b27b6",
        "storage_key": "property/6767906449167651/019fec35-a170-7625-b0cc-032a5e2b27b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHx_2hFhL9IgRR3lK6tYr-Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_404c56fb-2829-464e-bb0d-5ec3aeceac2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1510 Milstead Ave NE, Conyers, GA 30012, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-2da0-71fa-b2fc-9871fc6ef73f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-2da0-71fa-b2fc-9871fc6ef73f",
        "storage_key": "property/6767906449167651/019fec38-2da0-71fa-b2fc-9871fc6ef73f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1510+milstead+ave+ne-conyers-ga-30012/id=7742",
      "poi_directions_map_url": "https://maps.google.com/?cid=10346541326032724507",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.6830546",
      "poi_longitude": "-84.00161519999999",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-785-7128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9cQi5G09YgRG2IUiIRMlo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_aba12a49-b0ba-4efd-8766-af34bfd6aacd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2195 GA-20 SE, Conyers, GA 30013, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-2ba3-7794-a59b-f82bfb223dd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-2ba3-7794-a59b-f82bfb223dd5",
        "storage_key": "property/6767906449167651/019fec38-2ba3-7794-a59b-f82bfb223dd5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/conyers/2174",
      "poi_directions_map_url": "https://maps.google.com/?cid=14970885446257358017",
      "poi_item_slug": "target",
      "poi_latitude": "33.6329612",
      "poi_longitude": "-84.0169076",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-785-6470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a15d-73ec-a3af-c93c530418f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a15d-73ec-a3af-c93c530418f3",
        "storage_key": "property/6767906449167651/019fec35-a15d-73ec-a3af-c93c530418f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ27lQd19L9IgRwTQ8hf5Ew88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_1fbc49ac-d79a-4596-8bb4-0e14fdfb7612",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "BJ's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1800 Dogwood Dr SE, Conyers, GA 30013, USA",
      "poi_short_description": "Membership-only retail chain offering bulk groceries, electronics & more in a warehouse-like space.",
      "poi_long_description": "Membership-only retail chain offering bulk groceries, electronics & more in a warehouse-like space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-2e55-72d8-86a5-d7bc527ea352.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-2e55-72d8-86a5-d7bc527ea352",
        "storage_key": "property/6767906449167651/019fec38-2e55-72d8-86a5-d7bc527ea352.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bjs.com/cl/conyers/0150/?trc=locl%7Cggmb%7Cweb%7Cxlob%7Cxlob%7Clocdist%7C0150%7Cstore%7C20240816",
      "poi_directions_map_url": "https://maps.google.com/?cid=8113227841498443450",
      "poi_item_slug": "bjs",
      "poi_latitude": "33.642167",
      "poi_longitude": "-83.9834609",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-761-2358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a15d-73ec-a3af-c93c530418f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a15d-73ec-a3af-c93c530418f3",
        "storage_key": "property/6767906449167651/019fec35-a15d-73ec-a3af-c93c530418f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG0Gy0i9L9IgRuu5Scrz5l3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_00b964f9-ec00-4a8c-901e-e15ad3ef0418",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Flat Shoals Elementary School",
      "poi_type": "Education",
      "poi_address": "1455 Flat Shoals Rd SE, Conyers, GA 30013, USA",
      "poi_short_description": "Public elementary school, Rockdale County Public Schools.",
      "poi_long_description": "Public elementary school, Rockdale County Public Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-3115-70be-b8f5-08fc81893445.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-3115-70be-b8f5-08fc81893445",
        "storage_key": "property/6767906449167651/019fec38-3115-70be-b8f5-08fc81893445.webp",
        "width": 1280,
        "height": 1135
      },
      "poi_business_url": "https://fse.rockdaleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7108962295862222853",
      "poi_item_slug": "flat-shoals-elementary-school",
      "poi_latitude": "33.6326141",
      "poi_longitude": "-83.99177999999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-483-5136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a19c-721d-a9e2-990c546b5fec",
        "storage_key": "property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDZDySj9L9IgRBWCDDosbqGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_80db5900-b922-4901-abca-b081a376a700",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Conyers Middle School",
      "poi_type": "Education",
      "poi_address": "400 Sigman Rd, Conyers, GA 30012, USA",
      "poi_short_description": "Public middle school, Rockdale County Public Schools.",
      "poi_long_description": "Public middle school, Rockdale County Public Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-324e-7571-b345-f1b077efc1e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-324e-7571-b345-f1b077efc1e4",
        "storage_key": "property/6767906449167651/019fec38-324e-7571-b345-f1b077efc1e4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cms.rockdaleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2097014336862466385",
      "poi_item_slug": "conyers-middle-school",
      "poi_latitude": "33.6839165",
      "poi_longitude": "-84.00467859999999",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-483-3371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a19c-721d-a9e2-990c546b5fec",
        "storage_key": "property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuRxGR5C09YgRUbGWzW0XGh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_0b34840e-60a1-4a4c-906f-2508658125ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Rockdale County High School",
      "poi_type": "Education",
      "poi_address": "1174 Bulldog Cir NE, Conyers, GA 30012, USA",
      "poi_short_description": "Public high school, Rockdale County Public Schools.",
      "poi_long_description": "Public high school, Rockdale County Public Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-33ce-762e-a6a3-6d41cea35f9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-33ce-762e-a6a3-6d41cea35f9c",
        "storage_key": "property/6767906449167651/019fec38-33ce-762e-a6a3-6d41cea35f9c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://rchs.rockdaleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8067991831130483788",
      "poi_item_slug": "rockdale-county-high-school",
      "poi_latitude": "33.6675885",
      "poi_longitude": "-84.00798569999999",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-483-8754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a19c-721d-a9e2-990c546b5fec",
        "storage_key": "property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh0JDhKS09YgRTCxJCdND928",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a1c8b539-cb7a-4ebf-bb3e-fe34ae59dd90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Salem High School",
      "poi_type": "Education",
      "poi_address": "3551 Underwood Rd SE, Conyers, GA 30013, USA",
      "poi_short_description": "Public high school, Rockdale County Public Schools.",
      "poi_long_description": "Public high school, Rockdale County Public Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-316a-771b-a71a-4641cb587fe9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-316a-771b-a71a-4641cb587fe9",
        "storage_key": "property/6767906449167651/019fec38-316a-771b-a71a-4641cb587fe9.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://shs.rockdaleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14234053072832102090",
      "poi_item_slug": "salem-high-school",
      "poi_latitude": "33.5954589",
      "poi_longitude": "-83.9895401",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-929-0176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a19c-721d-a9e2-990c546b5fec",
        "storage_key": "property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp1gHS6NL9IgRyv42wNqDicU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_044aa056-5dd4-4f6b-b978-41b52d70822d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Rockdale Career Academy",
      "poi_type": "Education",
      "poi_address": "1064 Culpepper Dr SW, Conyers, GA 30094, USA",
      "poi_short_description": "Career and technical education high school, Rockdale County Public Schools.",
      "poi_long_description": "Career and technical education high school, Rockdale County Public Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-3cce-778f-a9f0-9390f29b4ba8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-3cce-778f-a9f0-9390f29b4ba8",
        "storage_key": "property/6767906449167651/019fec38-3cce-778f-a9f0-9390f29b4ba8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://rca.rockdaleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5760759954061871579",
      "poi_item_slug": "rockdale-career-academy",
      "poi_latitude": "33.648274",
      "poi_longitude": "-84.02222929999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-388-5677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a19c-721d-a9e2-990c546b5fec",
        "storage_key": "property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7e9_NaxM9IgR20knCqhU8k8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f546726b-14e6-4016-8f43-ac4c7631cc92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "AMC Conyers Crossing 16",
      "poi_type": "Entertainment",
      "poi_address": "1536 Dogwood Dr SE, Conyers, GA 30013, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-3876-7543-8436-25d435bb07e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-3876-7543-8436-25d435bb07e4",
        "storage_key": "property/6767906449167651/019fec38-3876-7543-8436-25d435bb07e4.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/atlanta/amc-conyers-crossing-16?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4833029694757446612",
      "poi_item_slug": "amc-conyers-crossing-16",
      "poi_latitude": "33.6493322",
      "poi_longitude": "-83.9950282",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-929-0612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-6079-71be-95eb-e15374e8e477.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec38-6079-71be-95eb-e15374e8e477",
        "storage_key": "property/6767906449167651/019fec38-6079-71be-95eb-e15374e8e477.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxRUmEpL9IgR1KPuoOZeEkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ca61acb4-b73a-435d-a901-530b55825dd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Georgia International Horse Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1996 Centennial Olympic Pkwy NE, Conyers, GA 30013, USA",
      "poi_short_description": "Equestrian venue built for the 1996 Olympic Games; hosts horse shows, festivals and outdoor events.",
      "poi_long_description": "Equestrian venue built for the 1996 Olympic Games; hosts horse shows, festivals and outdoor events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-8c8e-7456-9c58-baaf295649a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-8c8e-7456-9c58-baaf295649a7",
        "storage_key": "property/6767906449167651/019fec35-8c8e-7456-9c58-baaf295649a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.georgiahorsepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1275071781745093866",
      "poi_item_slug": "georgia-international-horse-park",
      "poi_latitude": "33.662903",
      "poi_longitude": "-83.93198090000001",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-860-4190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13a-755c-b8e2-10cb4fb51887",
        "storage_key": "property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ83JZili19YgR6mwKpgf3sRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_46486cff-4265-49a1-801b-4f9344d2e50b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Conyers Rockdale Council for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "910 Center St NE, Conyers, GA 30012, USA",
      "poi_short_description": "Local arts council in Olde Town Conyers with exhibitions, performances and classes.",
      "poi_long_description": "Local arts council in Olde Town Conyers with exhibitions, performances and classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-39bf-747d-89ed-5dde66d21ecb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-39bf-747d-89ed-5dde66d21ecb",
        "storage_key": "property/6767906449167651/019fec38-39bf-747d-89ed-5dde66d21ecb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://conyersarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17792869926564606414",
      "poi_item_slug": "conyers-rockdale-council-for-the-arts",
      "poi_latitude": "33.6671075",
      "poi_longitude": "-84.01802289999999",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-922-3143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn79C61iz9YgRzjGdc-347PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_e67f92af-6be6-472e-a40c-9c6a30c51a47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Olde Town Conyers",
      "poi_type": "Entertainment",
      "poi_address": "Historic Train Depot, 901 Railroad St, Conyers, GA 30012, USA",
      "poi_short_description": "Historic downtown district around the old railroad depot, with shops, restaurants and community events.",
      "poi_long_description": "Historic downtown district around the old railroad depot, with shops, restaurants and community events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-54ac-7639-ad36-7c0362e98336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-54ac-7639-ad36-7c0362e98336",
        "storage_key": "property/6767906449167651/019fec38-54ac-7639-ad36-7c0362e98336.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://visitconyersga.com/olde-town-conyers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17231053763195733095",
      "poi_item_slug": "olde-town-conyers-ga",
      "poi_latitude": "33.6663913",
      "poi_longitude": "-84.0180429",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-602-2606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRXRUh1iz9YgRZ4TwhBoAIe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_9b22208a-a6f4-46b9-b2d0-a6223fec21f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Celebration Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "949 South Main St NE, Conyers, GA 30012, USA",
      "poi_short_description": "Small park featuring a koi pond and water features.",
      "poi_long_description": "Small park featuring a koi pond and water features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-3bfb-769d-8716-c92cf1fe5ae8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-3bfb-769d-8716-c92cf1fe5ae8",
        "storage_key": "property/6767906449167651/019fec38-3bfb-769d-8716-c92cf1fe5ae8.webp",
        "width": 900,
        "height": 900
      },
      "poi_business_url": "https://exploregeorgia.org/conyers/outdoors-nature/natural-attractions/celebration-park-in-olde-town-conyers",
      "poi_directions_map_url": "https://maps.google.com/?cid=4102501001236576487",
      "poi_item_slug": "celebration-park",
      "poi_latitude": "33.6662694",
      "poi_longitude": "-84.0169707",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-602-2606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13a-755c-b8e2-10cb4fb51887",
        "storage_key": "property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-f_avPFJ9IgR5_hjtewC7zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_74c8953d-95e3-4a24-a337-f30dddfc7256",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Monastery of The Holy Spirit",
      "poi_type": "Entertainment",
      "poi_address": "2625 GA-212 SW, Conyers, GA 30094, USA",
      "poi_short_description": "Religious complex featuring a monk-run bakery, bonsai store, gardens & religious retreats.",
      "poi_long_description": "Religious complex featuring a monk-run bakery, bonsai store, gardens & religious retreats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-3e6f-76d9-a0e7-a3256615912a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-3e6f-76d9-a0e7-a3256615912a",
        "storage_key": "property/6767906449167651/019fec38-3e6f-76d9-a0e7-a3256615912a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.trappist.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8010448192932354150",
      "poi_item_slug": "monastery-of-the-holy-spirit",
      "poi_latitude": "33.5838126",
      "poi_longitude": "-84.0680118",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 9 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 770-483-8705",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-60b2-76a2-b646-8e5114a1c28d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec38-60b2-76a2-b646-8e5114a1c28d",
        "storage_key": "property/6767906449167651/019fec38-60b2-76a2-b646-8e5114a1c28d.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfywdMlN9IgRZhhntzDUKm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_e509739d-3a88-4b17-8a73-24b989f71811",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Piedmont Rockdale Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1412 Milstead Ave NE, Conyers, GA 30012, USA",
      "poi_short_description": "Piedmont Rockdale Hospital, the acute-care hospital serving Rockdale County, on Milstead Avenue in Conyers.",
      "poi_long_description": "Piedmont Rockdale Hospital, the acute-care hospital serving Rockdale County, on Milstead Avenue in Conyers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-87f6-774e-a981-7d1b489d6ca1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-87f6-774e-a981-7d1b489d6ca1",
        "storage_key": "property/6767906449167651/019fec35-87f6-774e-a981-7d1b489d6ca1.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-rockdale?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY5NDItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2661675336474305549",
      "poi_item_slug": "piedmont-rockdale",
      "poi_latitude": "33.6808174",
      "poi_longitude": "-84.00133149999999",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-918-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a14c-744a-9da6-b3bed194fc80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a14c-744a-9da6-b3bed194fc80",
        "storage_key": "property/6767906449167651/019fec35-a14c-744a-9da6-b3bed194fc80.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJuSz3VZe09YgRDST4yZ0r8CQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_174b5fc4-d179-4932-af61-f54edc8029a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Piedmont Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1280 Dogwood Dr SE, Conyers, GA 30013, USA",
      "poi_short_description": "Walk-in urgent care clinic on Dogwood Drive, part of Piedmont Healthcare.",
      "poi_long_description": "Walk-in urgent care clinic on Dogwood Drive, part of Piedmont Healthcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-4007-700f-9075-40a0f49866b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-4007-700f-9075-40a0f49866b4",
        "storage_key": "property/6767906449167651/019fec38-4007-700f-9075-40a0f49866b4.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.piedmonturgentcare.org/locations/conyers-ga?location=120&utm_source=rioseo&utm_medium=local&utm_content=clinic_link_120",
      "poi_directions_map_url": "https://maps.google.com/?cid=18345421602859240191",
      "poi_item_slug": "piedmont-urgent-care",
      "poi_latitude": "33.6550416",
      "poi_longitude": "-84.00251170000001",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-994-4662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF5Hn6ue19YgR_8oz5b8HmP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_837b2235-3d17-4566-8a3c-09451b995caf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Atlanta Plus Primary & Urgent Care Conyers",
      "poi_type": "Health and Wellness",
      "poi_address": "2121 Salem Rd SE, Conyers, GA 30013, USA",
      "poi_short_description": "Walk-in urgent care and primary care clinic on Salem Road.",
      "poi_long_description": "Walk-in urgent care and primary care clinic on Salem Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-4258-753d-91ca-388bfc931cf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-4258-753d-91ca-388bfc931cf2",
        "storage_key": "property/6767906449167651/019fec38-4258-753d-91ca-388bfc931cf2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://atlantapuc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11013584833937889945",
      "poi_item_slug": "atlanta-plus-primary--urgent-care-conyers",
      "poi_latitude": "33.6346012",
      "poi_longitude": "-83.9787978",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-679-4360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu6JdP95L9IgRmVp_0g0d2Jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_080d3f3a-43d7-4618-8411-602edd53baad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1680 Hwy 138 SE, Conyers, GA 30013, USA",
      "poi_short_description": "Spacious gym with hydromassages and massage chairs that offers an app for equipment tutorials.",
      "poi_long_description": "Spacious gym with hydromassages and massage chairs that offers an app for equipment tutorials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-82d2-7186-b952-af0d0b315f86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-82d2-7186-b952-af0d0b315f86",
        "storage_key": "property/6767906449167651/019fec35-82d2-7186-b952-af0d0b315f86.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/conyers-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13445487891485381618",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.6452142",
      "poi_longitude": "-84.01242049999999",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 678-413-9755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1xGo1ZL9IgR8lPNAwD4l7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_84b19b6c-d626-4de5-bcec-b046b896d2b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "CrossFit Rockdale",
      "poi_type": "Health and Wellness",
      "poi_address": "1774 Old Covington Rd NE, Conyers, GA 30013, USA",
      "poi_short_description": "Casual space offering CrossFit-based fitness training, plus coaching.",
      "poi_long_description": "Casual space offering CrossFit-based fitness training, plus coaching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-4719-703e-baf6-ca71eed61430.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-4719-703e-baf6-ca71eed61430",
        "storage_key": "property/6767906449167651/019fec38-4719-703e-baf6-ca71eed61430.webp",
        "width": 1280,
        "height": 842
      },
      "poi_business_url": "http://www.crossfitrockdale.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6239513752148270104",
      "poi_item_slug": "crossfit-rockdale",
      "poi_latitude": "33.6541396",
      "poi_longitude": "-83.9882087",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-234-2947",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwDlTMy09YgRGFz2_7I0l1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_56fb9962-b20a-4e38-bde4-c4880b10ecbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Costley Mill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2455 Costley Mill Rd NE, Conyers, GA 30013, USA",
      "poi_short_description": "Large, 77-acre park with a waterfall pond and a picnic area, plus trails and a playground.",
      "poi_long_description": "Large, 77-acre park with a waterfall pond and a picnic area, plus trails and a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-91bf-7640-847c-e04a2b77862b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-91bf-7640-847c-e04a2b77862b",
        "storage_key": "property/6767906449167651/019fec35-91bf-7640-847c-e04a2b77862b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.costleymillpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17526148999035557532",
      "poi_item_slug": "costley-mill-park",
      "poi_latitude": "33.7073036",
      "poi_longitude": "-83.9302422",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-278-7209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13a-755c-b8e2-10cb4fb51887",
        "storage_key": "property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNQ_MvnbK9YgRnBYVOKhjOfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_311863dc-db48-477b-b18f-cb2efaf48d63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Rockdale County Earl O'Neal Sports Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2709 Old Covington Rd NE, Conyers, GA 30013, USA",
      "poi_short_description": "Facility with 8 fields, plus batting cages, hosting football and softball tournaments.",
      "poi_long_description": "Facility with 8 fields, plus batting cages, hosting football and softball tournaments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-4765-711c-93da-93bf791e3ba9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-4765-711c-93da-93bf791e3ba9",
        "storage_key": "property/6767906449167651/019fec38-4765-711c-93da-93bf791e3ba9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rockdalecountyga.gov/parks-and-trails/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16273846141745549365",
      "poi_item_slug": "rockdale-county-earl-oneal-sports-complex",
      "poi_latitude": "33.6352329",
      "poi_longitude": "-83.9528904",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-278-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ZOwax-z9YgRNdAa6NdQ2OE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_041af849-3d81-45d3-a9b4-501f833519cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Milstead Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1665 Main St NE, Conyers, GA 30012, USA",
      "poi_short_description": "Public park with a playground, picnic tables, and a splash pad, plus a public restroom.",
      "poi_long_description": "Public park with a playground, picnic tables, and a splash pad, plus a public restroom.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-46ed-745b-9272-c4693d63ae6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-46ed-745b-9272-c4693d63ae6c",
        "storage_key": "property/6767906449167651/019fec38-46ed-745b-9272-c4693d63ae6c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.rockdalecountyga.gov/parks-and-trails/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5531127949159100046",
      "poi_item_slug": "milstead-park",
      "poi_latitude": "33.6868709",
      "poi_longitude": "-83.991618",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-278-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13a-755c-b8e2-10cb4fb51887",
        "storage_key": "property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-09fNfK09YgRju7ciJCDwkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7426199b-f5b6-42a9-b138-4ce753304165",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Johnson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1781 Ebenezer Rd SW, Conyers, GA 30094, USA",
      "poi_short_description": "Grassy park with a playground, paved walking/biking trail & recreation center with an indoor pool.",
      "poi_long_description": "Grassy park with a playground, paved walking/biking trail & recreation center with an indoor pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-90ea-72ba-ada2-982cae0e1f2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-90ea-72ba-ada2-982cae0e1f2d",
        "storage_key": "property/6767906449167651/019fec35-90ea-72ba-ada2-982cae0e1f2d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.rockdalecountyga.gov/venue/johnson-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17689365493947880676",
      "poi_item_slug": "johnson-park",
      "poi_latitude": "33.64140160000001",
      "poi_longitude": "-84.0438356",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 770-278-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13a-755c-b8e2-10cb4fb51887",
        "storage_key": "property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXaJ88VM9IgR5NTQyDFAffU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_2d3a023c-f043-425a-89aa-ddc136e480e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Pine Log Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1451 Pine Log Rd NE, Conyers, GA 30012, USA",
      "poi_short_description": "Recreational space featuring picnic tables and a playground, as well as basketball and tennis courts.",
      "poi_long_description": "Recreational space featuring picnic tables and a playground, as well as basketball and tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-4830-723f-8586-4e6cae526b70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-4830-723f-8586-4e6cae526b70",
        "storage_key": "property/6767906449167651/019fec38-4830-723f-8586-4e6cae526b70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rockdalecountyga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=493143155739993988",
      "poi_item_slug": "pine-log-park",
      "poi_latitude": "33.6618274",
      "poi_longitude": "-83.9970902",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-761-3058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13a-755c-b8e2-10cb4fb51887",
        "storage_key": "property/6767906449167651/019fec35-a13a-755c-b8e2-10cb4fb51887.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3M5Lbi09YgRhCdMXRb_1wY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_80141cac-0b50-481e-93f7-b322f5d83022",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "East Conyers Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1877 Iris Dr SE, Conyers, GA 30013, USA",
      "poi_short_description": "Park-and-ride lot on Iris Drive for Xpress commuter buses to Atlanta.",
      "poi_long_description": "Park-and-ride lot on Iris Drive for Xpress commuter buses to Atlanta.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2200850480070033135",
      "poi_item_slug": "pr-east-conyers",
      "poi_latitude": "33.6408058",
      "poi_longitude": "-83.98761789999999",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 844-977-7742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-60b3-72ba-86dd-3b80c14e515d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec38-60b3-72ba-86dd-3b80c14e515d",
        "storage_key": "property/6767906449167651/019fec38-60b3-72ba-86dd-3b80c14e515d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJXx77XzBL9IgR735S3Nn9ih4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_a7758e4c-27c8-40a7-9377-b1de5dfabefa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-4f9b-704e-a6c4-a6fb61dcee86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-4f9b-704e-a6c4-a6fb61dcee86",
        "storage_key": "property/6767906449167651/019fec38-4f9b-704e-a6c4-a6fb61dcee86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "38.4 mi",
      "poi_walking_minutes": "14 hours 13 mins",
      "poi_biking_minutes": "3 hours 41 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a436-701d-b6d8-d78fd1b9e806.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a436-701d-b6d8-d78fd1b9e806",
        "storage_key": "property/6767906449167651/019fec35-a436-701d-b6d8-d78fd1b9e806.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_45e7e9c9-44e2-4e53-88d5-1cd184b87734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Rockdale County Public Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "960 Pine St NE, Conyers, GA 30012, USA",
      "poi_short_description": "District offices of Rockdale County Public Schools.",
      "poi_long_description": "District offices of Rockdale County Public Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-538f-7090-9de3-95e851bd59fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-538f-7090-9de3-95e851bd59fd",
        "storage_key": "property/6767906449167651/019fec38-538f-7090-9de3-95e851bd59fd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rockdaleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8992651018395599486",
      "poi_item_slug": "rockdale-county-public-schools",
      "poi_latitude": "33.6685523",
      "poi_longitude": "-84.0151776",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-483-4713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a19c-721d-a9e2-990c546b5fec",
        "storage_key": "property/6767906449167651/019fec35-a19c-721d-a9e2-990c546b5fec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv0SeeF6z9YgRfkKGxHRQzHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4bceae2e-2978-428d-aa0d-fcd936943c68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Pratt Industries, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1800 Sarasota Business Pkwy NE SuiteC, Conyers, GA 30013, USA",
      "poi_short_description": "Corrugated packaging and recycled paper company headquartered in Conyers.",
      "poi_long_description": "Corrugated packaging and recycled paper company headquartered in Conyers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-96bc-7409-96c1-ab30ce2bd8a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-96bc-7409-96c1-ab30ce2bd8a8",
        "storage_key": "property/6767906449167651/019fec35-96bc-7409-96c1-ab30ce2bd8a8.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.prattindustries.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3018853247174312715",
      "poi_item_slug": "pratt-industries-inc",
      "poi_latitude": "33.6586586",
      "poi_longitude": "-83.99104439999999",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-918-5678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcOzTc-09YgRCwPcoggf5Sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_86d345dc-40a6-4e25-8613-ee321bf5d572",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Tempur Sealy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1705 Industrial Blvd NW, Conyers, GA 30012, USA",
      "poi_short_description": "Mattress manufacturing plant (Tempur Sealy).",
      "poi_long_description": "Mattress manufacturing plant (Tempur Sealy).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-544c-715a-939d-5a1b3bdb2c25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-544c-715a-939d-5a1b3bdb2c25",
        "storage_key": "property/6767906449167651/019fec38-544c-715a-939d-5a1b3bdb2c25.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tempursealy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5788374884186443490",
      "poi_item_slug": "tempur-sealy",
      "poi_latitude": "33.6751772",
      "poi_longitude": "-84.0441122",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-483-3810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-_It4j2z9YgR4s65_klwVFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_d7a5681e-dfd1-463c-8e5c-14a8a5e78378",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Dart Container Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1455 GA-138, Conyers, GA 30013, USA",
      "poi_short_description": "Foodservice packaging manufacturing plant (Dart Container).",
      "poi_long_description": "Foodservice packaging manufacturing plant (Dart Container).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-58b3-71de-8f6d-60476140b3c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-58b3-71de-8f6d-60476140b3c4",
        "storage_key": "property/6767906449167651/019fec38-58b3-71de-8f6d-60476140b3c4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dartcontainer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5079973513531743657",
      "poi_item_slug": "dart-container-corporation",
      "poi_latitude": "33.65993",
      "poi_longitude": "-83.9974469",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-483-9556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAatasLe09YgRqd1z5v6wf0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_c6e79358-ee7a-41a9-be07-e3e945e02025",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Hillphoenix Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2016 Gees Mill Rd NE, Conyers, GA 30013, USA",
      "poi_short_description": "Commercial refrigeration manufacturer headquartered in Conyers.",
      "poi_long_description": "Commercial refrigeration manufacturer headquartered in Conyers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-58f5-72fb-90ed-ca82f0cacc97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-58f5-72fb-90ed-ca82f0cacc97",
        "storage_key": "property/6767906449167651/019fec38-58f5-72fb-90ed-ca82f0cacc97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hillphoenix.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=900659077481570012",
      "poi_item_slug": "hillphoenix-inc",
      "poi_latitude": "33.6529673",
      "poi_longitude": "-83.9788945",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-285-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9WQ-Xd94RQR3B4FuajIfww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_d8b19211-0255-4481-8e33-16ea50dd428d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "poi_name": "Golden State Foods",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1525 Old Covington Rd NE, Conyers, GA 30013, USA",
      "poi_short_description": "Food-service manufacturing and distribution facility (Golden State Foods).",
      "poi_long_description": "Food-service manufacturing and distribution facility (Golden State Foods).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec38-5a1d-763e-a812-fa4bb930f3e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec38-5a1d-763e-a812-fa4bb930f3e3",
        "storage_key": "property/6767906449167651/019fec38-5a1d-763e-a812-fa4bb930f3e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.goldenstatefoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6644604286024814677",
      "poi_item_slug": "golden-state-foods-1",
      "poi_latitude": "33.6578082",
      "poi_longitude": "-83.99589189999999",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-483-0711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec35-a13d-7739-a389-b5d952b9905d",
        "storage_key": "property/6767906449167651/019fec35-a13d-7739-a389-b5d952b9905d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRdjf87e09YgRVRCMvWRgNlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    }
  ],
  "office_hours": [
    {
      "id": "ec_42144b32d961cbadf0bf02fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_58c11592e1002802de4c689e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_647a01c499aac78e59e4e8db",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3bc83fe8d65a178c4997db99",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4d5b4dd742395099bb47fcf6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c6018847ff578a9239a1ebc5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_d07b99e131894492271817f6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "rating": "5",
      "name": "Kiera Miller",
      "text": "When I say impeccable customer service! From the very first phone call to walking in the door, I was greeted with the warmest welcome! The patience and care given for the community tour was outstanding. The property is beautiful and well laid out. My experience with Tayvin and Altivia were amazing! Tayvin  followed up after tour and made sure I had all the answers to my many questions. Beautiful Community Made My Move In A Wonderful Experience.",
      "date": "2026-07-24",
      "title": "false"
    },
    {
      "id": "ec_dd046c25b083df8af513d82d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "rating": "5",
      "name": "Ajsa Vaughn",
      "text": "I want to take the time to give a huge thank you to Altivia for making my move-in experience such an easy and smooth process. From the moment I applied for my unit, everything was handled professionally, efficiently, and with great communication. She was very helpful throughout the entire process, answered all of my questions, and made sure I understood everything every step of the way.\n\nWhat I appreciated the most was how stress-free the experience was. Moving can usually be overwhelming, but she made the transition feel simple and organized. There were no issues with my application or move-in process, and everything was completed in a timely manner. She was patient, attentive, and genuinely cared about making sure I was comfortable and satisfied.\n\nCustomer service like this is hard to find, and it truly made a difference in my experience. I highly recommend working with Altivia if you are looking for someone reliable, professional, and dedicated to helping people find and move into their new home smoothly. Thank you again for all of your help and for making this such a positive experience!",
      "date": "2026-05-20",
      "title": "false"
    },
    {
      "id": "ec_41659294da0b9df9ec3071ce",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "rating": "5",
      "name": "장유신",
      "text": "⭐️⭐️⭐️⭐️⭐️\n\nTayvin was incredibly helpful and kind throughout the entire leasing process. He was always quick to respond, patient with all of our questions, and made everything smooth and stress-free from beginning to end. Moving can be exhausting, but he made the experience so much easier. Truly appreciated his professionalism and friendly attitude. Highly recommend working with him!",
      "date": "2026-05-17",
      "title": "false"
    },
    {
      "id": "ec_8a9739ea4c7273a6a140f163",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "rating": "5",
      "name": "Dr. Roxanne Padmore, ND",
      "text": "I love living at the Quinn Residences! It is well upkept and quiet, and service requests are handled almost immediately. Maria was a wonderful leasing agent, and Altivia is an absolute standout. She has an amazing personality, truly listens, and is always on top of things. Highly recommended!",
      "date": "2026-06-22",
      "title": "false"
    },
    {
      "id": "ec_2781f55de2d93bb1d34f399b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "rating": "5",
      "name": "Pearl Kim",
      "text": "I almost couldn't move on the date I wanted because the appvesshield took time, but Tayven worked hard, so I signed the contract on the scheduled date of the move and moved safely\nTAEVEN well sympathized with and helped foreigners with the difficulties of living in other countries.\nI am so satisfied that the leaing office staff are all kind and the house is clean and quiet",
      "date": "2026-03-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_f42bfc2b-691c-40d2-b113-266be3355c16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Roberta home (4 bed, 2.5 bath, 2,108 sq ft)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Roberta",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=TeDko8p9YHS"
    },
    {
      "id": "custom_f3ef28ad-fd0b-4762-bb92-7b5e461bfc29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Xavier home (4 bed, 2.5 bath, 2,234 sq ft)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Xavier",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=K8S6syWt8AP"
    },
    {
      "id": "custom_c718efb0-2138-41ee-ab2d-73361e7b1031",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Sanford home (4 bed, 2.5 bath, 2,254 sq ft)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Sanford",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LGdL9t5qJvn"
    },
    {
      "id": "custom_09698dab-5d29-472e-afdb-d49a483bff89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Spencer home (4 bed, 2.5 bath, 2,116 sq ft)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Spencer",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=U29SWfTcukp"
    }
  ],
  "faqs": [
    {
      "id": "custom_2bda3efa-04e8-4c83-a486-fb1cbea95409",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_80d5a43c-db49-4fd8-ba24-9d85b64ad4b1",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_4ae593e3-9b6b-4188-9f92-f3a888ed7ef6",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_5a189099-5e70-4b27-816b-266ded9ad60e",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_8f9ded32-f34e-42ce-b827-a61986b4c5b9",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_20a07366-6ed5-46e8-9a5a-98d74441b2f5",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_45d13f59-d4d7-409b-9abc-0d85ec1e18d4",
      "question": "Landscape Services",
      "answer": "Single-family homes: $125/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_a0432744-4201-4278-8f09-81c8fbdfb2d2",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_491f52bd-8894-4420-b32d-f1b7a742e240",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_4abe7ff3-7649-4ce3-9c03-853979ba31b5",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_d95ca858-50bc-4630-a46b-16fee8107451",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_abfc5e04-ff8a-4bee-97e7-ecf0271226b1",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_2ca1a414-3c71-4615-a576-8f1bcf593d7e",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_0047198d-a89e-49d0-b305-67125e989aa6",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_1d9f1648-4c31-4d75-acd7-b56707007b1f",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_f1d269b0-cdb7-4e58-8a59-660a27fa44bc",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_31cd5891-ba18-4845-9e07-3ad005e4f2ab",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_421b52b7-dd3a-4525-b92e-a1f3a7c54662",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_ee4477ff-6edd-4dd2-82b0-8f105384cebb",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_100e4f1112122a0147894d6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "yardi",
      "external_id": "2332682",
      "pet_type": "all",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_edef9cafd154eef2c0d2400f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "yardi",
      "external_id": "2332680",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_d4499ef1382a6725ece7df6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "yardi",
      "external_id": "2332681",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-9e3b-767c-8069-7916b602599a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Quinn Residences at McCart Landing Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651"
    },
    {
      "lead_collector_id": "01a0abe0-9ead-714d-85bf-9fa99b85b6bf",
      "lead_source": "LANDING_PAGE",
      "name": "Quinn Residences at McCart Landing Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-in-unit-laundry-conyers-ga",
      "search_query": "luxury apartments with in-unit laundry Conyers GA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover luxury living at Quinn Residences in Conyers, GA. Enjoy the convenience of in-unit laundry and top-tier amenities in our upscale apartments.",
      "page_copy": "Located in the heart of Conyers, GA, Quinn Residences at McCart Landing offers luxury apartments with in-unit laundry among other modern conveniences. Residents appreciate the sleek design with stainless steel appliances and granite countertops, providing a sophisticated living environment. \n\nOur community is not only about luxurious interiors but also offers a stress-free lifestyle with amenities like a security deposit alternative and lawn maintenance. Experience exceptional living in Rockdale County with the added benefit of in-unit laundry facilities, making life at Quinn Residences truly singular.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry",
      "seo_description": "Explore luxury living in Conyers, GA with in-unit laundry, stainless steel appliances, and more at Quinn Residences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "smart-home-technology-apartments-rockdale-county",
      "search_query": "smart-home technology apartments in Rockdale County",
      "category": "Amenity",
      "h1_title": "Smart-Home Technology in Rockdale Apartments",
      "h2_subtitle": "Upgrade your lifestyle at Quinn Residences in Rockdale County. Experience smart-home technology that's designed for your convenience.",
      "page_copy": "At Quinn Residences at McCart Landing, we integrate cutting-edge smart-home technology into our luxurious apartments, situated in the charming Rockdale County. Residents enjoy the convenience and peace of mind provided by our state-of-the-art smart-home features combined with modern amenities like luxury flooring and stainless steel appliances.\n\nOur focus on advanced technology is matched by our commitment to a convenient lifestyle, with lawn maintenance and alternative security deposit options adding extra layers of ease. Located in the vibrant community of Conyers, GA, our residences are the perfect blend of innovation and comfort in the heart of Rockdale County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart-Home Tech Apartments in Rockdale",
      "seo_description": "Discover smart-home technology apartments in Rockdale County at Quinn Residences, with amenities like stainless steel appliances and luxury flooring.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "apartments-with-ev-chargers-near-30013",
      "search_query": "apartments with EV chargers near 30013",
      "category": "Amenity",
      "h1_title": "Apartments with EV Chargers Near 30013",
      "h2_subtitle": "Find eco-friendly living at Quinn Residences. Our apartments near 30013 come equipped with EV chargers and other modern amenities.",
      "page_copy": "Quinn Residences at McCart Landing in Conyers is setting a new standard for eco-friendly living with our apartments featuring EV chargers. Easily accessible to residents near the 30013 area, our community supports sustainable lifestyles while offering luxury finishes like granite countertops and stainless steel appliances.\n\nLocated in Rockdale County, Quinn Residences combines modern conveniences with green living. Our amenities not only include EV chargers but also a security deposit alternative and luxury flooring, ensuring a premium living experience. Experience the perfect harmony of convenience and sustainability just around the corner from the heart of Conyers, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with EV Chargers Near 30013",
      "seo_description": "Explore Quinn Residences near 30013, featuring EV chargers, luxurious amenities like granite countertops, and stainless steel appliances.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "granite-countertops-stainless-steel-appliances-conyers",
      "search_query": "granite countertops and stainless steel appliances Conyers",
      "category": "Amenity",
      "h1_title": "Granite Countertops & Stainless Steel in Conyers",
      "h2_subtitle": "Experience stylish living at Quinn Residences, Conyers, with elegant granite countertops and stainless steel appliances in every apartment.",
      "page_copy": "Quinn Residences at McCart Landing in Conyers, GA, offers the perfect blend of style and functionality with our beautifully crafted granite countertops and modern stainless steel appliances. These high-end features make cooking and entertaining effortless and enjoyable, setting a luxurious tone throughout the apartment.\n\nNestled in picturesque Rockdale County, our community combines the charm of high-quality interiors with practical amenities such as lawn maintenance and a security deposit alternative. Discover the convenience and elegance awaiting you at Quinn Residences, where premium finishes elevate your living experience in the heart of Conyers, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite Countertops, Stainless Steel in Conyers",
      "seo_description": "Discover Quinn Residences in Conyers with granite countertops and stainless steel appliances, offering a blend of style and modern convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "spacious-closet-apartments-rockdale-county",
      "search_query": "spacious closet apartments in Rockdale County",
      "category": "Amenity",
      "h1_title": "Spacious Closet Apartments in Rockdale",
      "h2_subtitle": "Explore Quinn Residences in Rockdale County. Enjoy apartments with spacious closets and modern amenities for comfortable living.",
      "page_copy": "At Quinn Residences at McCart Landing, discover the perfect place to call home with our spacious closet apartments in the heart of Rockdale County. These expansive storage spaces ensure you have ample room for all your belongings, enhancing the comfort and practicality of your living environment.\n\nLocated in charming Conyers, GA, our community offers more than just generous closet storage. Enjoy contemporary amenities such as stainless steel appliances, granite countertops, and lawn maintenance services. Come home to a blend of style and convenience at Quinn Residences, where spacious closets meet modern luxury.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Closet Apartments in Rockdale",
      "seo_description": "Experience Quinn Residences in Rockdale County, offering spacious closet apartments with modern amenities like granite countertops and stainless steel appliances.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "four-bedroom-apartments-conyers-ga",
      "search_query": "four bedroom apartments in Conyers GA",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments in Conyers, GA",
      "h2_subtitle": "Discover luxury living at Quinn Residences in Conyers, GA. Our four-bedroom apartments offer generous space and modern amenities.",
      "page_copy": "Quinn Residences at McCart Landing offers four-bedroom apartments in Conyers, GA, designed to provide families or roommates with the ideal blend of space and comfort. Each apartment features generous living areas complemented by high-end amenities such as stainless steel appliances and granite countertops, making it perfect for both relaxation and entertaining.\n\nConveniently located in the heart of Rockdale County, our community enhances living with features like lawn maintenance and a unique security deposit alternative. Whether you're growing a family or need extra room, Quinn Residences is the perfect starting point for a spacious, contemporary lifestyle in Conyers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments in Conyers, GA",
      "seo_description": "Explore four-bedroom apartments at Quinn Residences in Conyers, GA, featuring spacious layouts and modern amenities like granite countertops and stainless steel appliances.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "apartments-near-oxford-college-emory-university-conyers",
      "search_query": "apartments near Oxford College Emory University Conyers",
      "category": "School",
      "h1_title": "Apartments Near Oxford College, Conyers",
      "h2_subtitle": "Find your home at Quinn Residences in Conyers, conveniently located near Oxford College of Emory University, complete with modern amenities.",
      "page_copy": "Located conveniently in Conyers, GA, Quinn Residences at McCart Landing offers an ideal living solution for students and faculty seeking apartments near Oxford College of Emory University. Enjoy the comfort of our modern homes with amenities such as stainless steel appliances and granite countertops that bring luxury into everyday living.\n\nApartments at Quinn Residences are designed to suit both academic and personal lifestyles, with benefits like lawn maintenance and a security deposit alternative. Experience a supportive community setting while being just minutes away from the rich academic opportunities at Oxford College, all set within the charming backdrop of Rockdale County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oxford College in Conyers",
      "seo_description": "Quinn Residences in Conyers offers modern apartments near Oxford College of Emory University, featuring amenities like granite countertops and stainless steel appliances.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "apartments-near-piedmont-rockdale-conyers-ga",
      "search_query": "apartments near Piedmont Rockdale Conyers GA",
      "category": "Hospital",
      "h1_title": "Apartments Near Piedmont Rockdale, Conyers",
      "h2_subtitle": "Quinn Residences offers convenient living near Piedmont Rockdale Hospital in Conyers, GA. Enjoy access to modern amenities and comfort.",
      "page_copy": "Quinn Residences at McCart Landing presents an excellent living option for those seeking apartments near Piedmont Rockdale Hospital in Conyers, GA. Our community combines convenience with modern living, providing easy access to the hospital and surrounding medical facilities. Each apartment is equipped with luxurious amenities, including stainless steel appliances and granite countertops, ensuring a comfortable and stylish home environment.\n\nResidents will appreciate the thoughtfully designed common spaces and services, such as lawn maintenance and the option of a security deposit alternative. Situated in the heart of Rockdale County, Quinn Residences serves the needs of healthcare professionals and families alike, offering easy commutes and a welcoming community atmosphere.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont Rockdale in Conyers",
      "seo_description": "Discover Quinn Residences in Conyers, near Piedmont Rockdale Hospital, featuring modern amenities like granite countertops and stainless steel appliances.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "apartments-near-georgia-international-horse-park-conyers",
      "search_query": "apartments near georgia international horse park conyers",
      "category": "Park",
      "h1_title": "Apartments Near Georgia International Horse Park",
      "h2_subtitle": "Explore Quinn Residences, ideally situated near Georgia International Horse Park in Conyers. Enjoy contemporary living with exceptional amenities.",
      "page_copy": "Quinn Residences at McCart Landing offers a prime location for equestrian enthusiasts looking for apartments near the Georgia International Horse Park in Conyers. Our beautifully appointed apartments provide a comfortable ambiance with high-end fixtures such as luxury flooring and granite countertops.\n\nLiving close to the Horse Park means you're just a short drive from events and activities, while still enjoying the comfort of home. Quinn Residences ensures a worry-free lifestyle with lawn maintenance and a security deposit alternative, letting residents focus on recreation and relaxation in the scenic backdrop of Rockdale County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia International Horse Park",
      "seo_description": "Discover Quinn Residences in Conyers, near the Georgia International Horse Park, with amenities like luxury flooring and granite countertops.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "housing-close-to-costley-mill-park-rockdale-county",
      "search_query": "housing close to costley mill park rockdale county",
      "category": "Park",
      "h1_title": "Housing Close to Costley Mill Park",
      "h2_subtitle": "Quinn Residences offers ideal housing near Costley Mill Park in Rockdale County. Enjoy modern amenities amid natural beauty.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Quinn Residences at McCart Landing, housing close to Costley Mill Park in Rockdale County. This prime location provides residents with quick access to the serene outdoor spaces of one of the county's most beautiful parks. The residences boast modern luxury, featuring stainless steel appliances and granite countertops.\n\nWith amenities like lawn maintenance and a security deposit alternative, Quinn Residences focus on providing an enriching living experience. Whether you're looking to explore nature or enjoy quiet time at home, our community makes it all possible in the scenic environment of Rockdale County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Costley Mill Park, Rockdale County",
      "seo_description": "Quinn Residences offers modern housing near Costley Mill Park, Rockdale County, featuring amenities like granite countertops and stainless steel appliances.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167651",
      "source": "generator",
      "page_item_url": "quinn-residences-near-city-pond-park-30013",
      "search_query": "quinn residences near city pond park 30013",
      "category": "Park",
      "h1_title": "Quinn Residences Near City Pond Park",
      "h2_subtitle": "Explore Quinn Residences, located conveniently near City Pond Park in the 30013 area of Conyers. Enjoy outstanding amenities and vibrant surroundings.",
      "page_copy": "Located in the heart of Conyers, Quinn Residences at McCart Landing offers exceptional living near City Pond Park in the 30013 zip code. Our community combines the tranquility of park-side living with the convenience of modern amenities, including stainless steel appliances and luxury flooring.\n\nResidents benefit from our commitment to ease of living with services like lawn maintenance and a security deposit alternative. Whether you're an outdoor enthusiast eager to explore City Pond Park or someone seeking a vibrant community, Quinn Residences is the perfect place to call home in Rockdale County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Quinn Residences Near City Pond Park 30013",
      "seo_description": "Discover Quinn Residences near City Pond Park, featuring luxurious amenities like stainless steel appliances, in the 30013 Conyers area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977251485"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KH59T629"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57160263295"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwn5ll5wd2"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/0a441b43-eb5e-4204-8b35-4efd133386e8/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f575e7a0-ff93-11ef-9458-575254a4491c"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-606-1667"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "844-534-0623"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977251485",
  "custom_google_gtm_id": "GTM-KH59T629",
  "custom_rollout_phase": "Phase 1",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57160263295",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rkwn5ll5wd2",
  "custom_self_guided_tour_url": "https://selftournow.com/property/0a441b43-eb5e-4204-8b35-4efd133386e8/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f575e7a0-ff93-11ef-9458-575254a4491c",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "844-606-1667",
  "custom_paid_social_tracking_phone_number": "844-534-0623",
  "custom_audioeye_site_id": "1a75d0b9-8e99-446c-8712-f7ac57cd29cb",
  "custom_audioeye_site_hash": "66b490916edcd11a309f7e9fc3c7b492"
};

export const generatedAt = '2026-10-30T17:28:07.546Z';
